import React, { useState, useContext, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { useTheme } from '@material-ui/core';
import { Button } from '../../components/ui/forms/Button';
import { useSnackbar } from 'notistack';
import { DatabaseContext } from '../../contexts/DatabaseContext';
import { UserContext } from '../../contexts/UserContext';
import Axios from 'axios';
import { Grid } from '@material-ui/core';
import { Sites } from '../Admin/Sites';
import { PatronContext } from '../../contexts/PatronContext';

const SynchronizeImport = () => {
  const { Site, email } = useContext(UserContext);
  const { apiUrl } = useContext(DatabaseContext);
  const { enqueueSnackbar } = useSnackbar();
  const { palette } = useTheme();
  const { siteCode } = Site;
  const [WB, setWB] = useState(false);
  const [loading, setLoading] = useState(null);
  const { GetWondeImportDate, wondeImportDate } = useContext(PatronContext);

  useEffect(() => {
    GetWondeImportDate();
  }, []);

  const wondeImport = async () => {
    setWB(true);
    setLoading(true);
    try {
      const res = await Axios.put(
        `${apiUrl}/api/sync/wonde?siteCode=${Site.siteCode}&user=${email}&recordPerPage=1`
      );
    } catch (err) {
      setWB(false);
      setLoading(false);
      enqueueSnackbar(err.response.data.error, {
        variant: 'error',
        autoHideDuration: 6000,
      });
      throw err.message;
    }
    setWB(false);
    setLoading(false);
  };

  const compassImport = async () => {
    try {
      const res = await Axios.get(
        `${apiUrl}/api/sync/compass/?siteCode=${siteCode}&user=${email}`
      );
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: 'error',
        autoHideDuration: 6000,
      });
      throw err.message;
    }
  };

  return (
    <Container>
      <Button
        style={{ width: '30%' }}
        disabled={!Site.wondeAllowed || WB == true}
        colour='info'
        onClick={wondeImport}
      >
        Wonde
      </Button>
      {Site.wondeAllowed ? (
        <p style={{ color: 'orange' }}>Last Imported Date: {wondeImportDate}</p>
      ) : (
        <>
          <p>
            Schools that allow WONDE to interface with there student management
            <br />
            systems can use this import facility to import student data.
            <br />
            <br />
            If you wish to use this facility please contact Monitor WA
          </p>
        </>
      )}
      {loading > 0 ? (
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={6}>
            <p style={messageStyle}>
              Importing Student data from WONDE, this process can take several
              minutes. You will receive a confirmation email upon completion of
              the import.
            </p>
          </Grid>
          <Grid item xs={12} sm={12} md={4}></Grid>
        </Grid>
      ) : (
        <></>
      )}
      <br /> <br />
      {/* <Button
        style={{ width: '30%' }}
        disabled={!Site.compassAllowed}
        onClick={compassImport}
        colour='info'
      >
        Compass
      </Button> */}
    </Container>
  );
};

const iconStyles = {
  fontSize: '17px',
};

const Container = styled.div`
  padding: 2rem 4rem;
`;

const StyledButton = styled(Button)`
  width: 100%;
`;

const messageStyle = {
  fontSize: 18,
  color: '#ffffff',
};

export default SynchronizeImport;
